/* Big B collection hover covers (Sep 2026)
   On hover, cross-fades the card's background through a random handful
   of product covers from the collection. The logo image and title stay
   on top (see component-collection-hover-covers.css). Covers are only
   created (and therefore only downloaded) on first hover. Each hover
   reshuffles, so the covers differ every time. Desktop pointers only;
   respects prefers-reduced-motion. */
(function () {
  'use strict';

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var CYCLE_MS = 1600; /* time each cover is shown */
  var MAX_SHOWN = 6; /* covers per hover session */

  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i];
      arr[i] = arr[j];
      arr[j] = t;
    }
    return arr;
  }

  function setup(container) {
    if (container.dataset.hcInit) return;
    container.dataset.hcInit = 'true';

    var urls = (container.getAttribute('data-covers') || '')
      .split('|')
      .map(function (u) {
        return u.trim();
      })
      .filter(Boolean);
    if (urls.length === 0) return;

    var wrapper = container.closest('.card-wrapper');
    var card = container.parentElement; /* .card (card--hover-covers) */
    if (!wrapper || !card) return;

    var imgs = null; /* url -> <img>, built lazily on first hover */
    var order = [];
    var pos = 0;
    var timer = null;
    var currentUrl = null;

    function build() {
      imgs = {};
      urls.forEach(function (u) {
        var img = document.createElement('img');
        img.src = u;
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        img.decoding = 'async';
        container.appendChild(img);
        imgs[u] = img;
      });
    }

    function show(url) {
      if (currentUrl && imgs[currentUrl]) {
        imgs[currentUrl].classList.remove('is-visible');
      }
      if (imgs[url]) {
        imgs[url].classList.add('is-visible');
      }
      currentUrl = url;
    }

    function next() {
      pos = (pos + 1) % order.length;
      show(order[pos]);
    }

    function start() {
      if (!imgs) build();
      order = shuffle(urls.slice()).slice(0, MAX_SHOWN);
      pos = 0;
      show(order[0]);
      container.classList.add('is-active');
      card.classList.add('hover-covers-active');
      if (timer) clearInterval(timer);
      timer = setInterval(next, CYCLE_MS);
    }

    function stop() {
      container.classList.remove('is-active');
      card.classList.remove('hover-covers-active');
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    wrapper.addEventListener('mouseenter', start);
    wrapper.addEventListener('mouseleave', stop);
  }

  function init() {
    document.querySelectorAll('.collection-hover-covers').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init when sections reload inside the theme editor */
  document.addEventListener('shopify:section:load', init);
})();
